/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_C3Inputs */

const en_guide_json_schema_c3 = /** @type {(inputs: Guide_Json_Schema_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where a schema beats a TypeScript interface`)
};

const ko_guide_json_schema_c3 = /** @type {(inputs: Guide_Json_Schema_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스키마가 TypeScript 인터페이스보다 나은 지점`)
};

const ja_guide_json_schema_c3 = /** @type {(inputs: Guide_Json_Schema_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキーマがTypeScriptインターフェースに勝る場面`)
};

/**
* | output |
* | --- |
* | "Where a schema beats a TypeScript interface" |
*
* @param {Guide_Json_Schema_C3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_c3 = /** @type {((inputs?: Guide_Json_Schema_C3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_C3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_c3(inputs)
	if (locale === "ko") return ko_guide_json_schema_c3(inputs)
	return ja_guide_json_schema_c3(inputs)
});